import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nhtve2pux8: FaireBrandEntity = {
  token: "b_nhtve2pux8",
  type: "brand",
  name: "Minimalist Folk Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/e55241d2a849778177afb49f1098276b51aaa242901359e07a79e058438a972a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/26e3cfa3d31c4b488fb465c041036285be0ede9b747e9b2f4b0c1b3c31986084.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e55241d2a849778177afb49f1098276b51aaa242901359e07a79e058438a972a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/26e3cfa3d31c4b488fb465c041036285be0ede9b747e9b2f4b0c1b3c31986084.png",
  location: "Oceanside, CA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Minimalist Folk Co. is made for little folks with big personalities. Born in Oceanside, California, our brand celebrates the carefree spirit of childhood along the coast—where sandy toes, salty hair, and endless play inspire every design.\n\nOur pieces are crafted to stand out with thoughtful details, hold up through every adventure, and be cherished long enough to be passed down. With a focus on comfort and expression, each garment blends premium quality with playful design, making them just as perfect for everyday exploring as they are for picture-perfect memories.\n\nDesigned to be worn on repeat, Minimalist Folk Co. is more than clothing—it’s a collection of stories waiting to be lived in, shared, and remembered.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:16.103Z",
    importedBy: "entity-db-cli",
  },
};
